import { css } from 'linaria';

export const orderSectionCardGrid = css`
  && {
    @media (--only-mobile) {
      grid-template-rows: 1fr;
    }
  }
`;

export const orderSectionDesignSignupCard = css`
  @media (--only-mobile) {
    display: none;
  }
`;
